<template>
<div v-if="currentApplication !== null">
  <heading>Status</heading>
  <p>{{ status | capitalize }} • Last updated {{ currentApplication.updatedAt | formatDate }} </p>
  <divider />
  <div v-if="currentApplication.referralId !== null">
    <heading>Referrer</heading>
      <user-row-card :user="user" />
    <divider />
    <heading>Referral Reward</heading>
      <reward :min="referrerRewardMin" :max="referrerRewardMax" :rewardPercentage="currentJob.rewardPercentage" cssClass="inline normal f-14" title="in VIBES *" :referrer="currentApplication.referralId !== null" />
    <divider />
  </div>
  <heading>Jobseeker Reward</heading>
    <reward :min="referrerRewardMin" :max="referrerRewardMax" :rewardPercentage="currentJob.rewardPercentage" cssClass="inline normal f-14" title="in VIBES *" :referrer="currentApplication.referralId !== null" />
  <divider />
  <heading>* VIBES Terms</heading>
  <p class="text">VIBES prices are variable. The exact VIBES amount you will receive will
     be calculated at the time and date the offer is accepted by the worker</p>
  <divider />
  <field label="CV">
    <resume-upload-field v-model="resume" :is-full-width="true" :disable="true" />
  </field>
  <divider />
  <div v-if="currentApplication.coverLetter">
    <heading>Cover Letter</heading>
    <text-view class="text-view">
      {{ currentApplication.coverLetter }}
    </text-view>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Divider from '@/components/general/divider'
import Heading from '@/components/general/heading'
import Field from '@/components/general/field'
import UserRowCard from '@/components/general/user-row-card'
import ResumeUploadField from '@/components/jobseekers/resume-upload-field'
import TextView from '@/components/general/text-view'
import Currency from '@/components/general/currency'
import GlobalData from '@/helpers/global-data'
import Reward from '@/components/jobs/reward'
import RewardHelper from '@/helpers/reward'
import UserHelper from '@/helpers/user'
import _ from 'lodash'
import moment from 'moment'

export default {
  components: {
    Divider,
    Heading,
    Field,
    UserRowCard,
    ResumeUploadField,
    TextView,
    Currency,
    GlobalData,
    Reward
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('jobs', [
      'currentJob',
      'currentApplication'
    ]),
    status: function () {
      let status = this.currentApplication.status
      if (status === 'pending') return 'applied'
      else return status
    },
    user: function () {
      let application = this.currentApplication
      let user = {
        profilePictureUrl: UserHelper.getProfilePicture(application.referrerProfilePictureUrl, application.referrerId),
        firstName: application.referrerFirstName,
        lastName: application.referrerLastName,
        location: application.referrerLocation,
        role: application.referrerRole,
        companyName: application.referrerCompanyName
      }
      return user
    },
    referralFraction () {
      return GlobalData.referralFraction()
    },
    referrerRewardMin () {
      const f = this.currentApplication.referralId ? this.referralFraction : 1
      return RewardHelper.user(this.currentJob.minReward, this.currentJob.rewardPercentage) * f
    },
    referrerRewardMax () {
      const f = this.currentApplication.referralId ? this.referralFraction : 1
      return RewardHelper.user(this.currentJob.maxReward, this.currentJob.rewardPercentage) * f
    }
  },
  methods: {
    ...mapActions('jobs', [
      'getApplication'
    ])
  },
  filters: {
    capitalize (value) {
      return _.capitalize(value)
    },
    formatDate (value) {
      return moment(value).format('DD MMM YY')
    }
  },
  async mounted () {
    this.getApplication(this.currentJob.id)
  },
  data () {
    return {
      resume: ''
    }
  }
}
</script>

<style lang="scss">
.field.is-spaced {
  display: flex;
  justify-content: space-between;
}
.is-right {
  float: right;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/application-page.vue